<div class="filterOffcanvas__calenderbody"  [style.borderColor]="borderColor" >
    <div class="filterOffcanvas__calenderWrapper" class="d-flex w-100">
        <input class="date_picker" type="date" [formControl]="control" [max]="maxDate" [min]="minDate" (change)="onDateChange($event)"
            (click)="openDatePicker($event)"  #nativeDateInput   onkeydown="return false" (focus)="openDatePicker($event)" />
        <input type="text" class="custom-date-input form-control filterOffcanvas__inputlabel_cal"
            placeholder="dd-MM-yyyy" [readonly]="true" [value]="formattedDate" readonly
            (click)="nativeDateInput.click()"  />
            <span class="calendar-icon" >
                <app-common-icon [faIcon]="faCalendar" (clickEvent)="nativeDateInput.click()"></app-common-icon>
              </span>
    </div>
</div>